import(/* webpackMode: "eager" */ "/vercel/path0/src/app/beds/page.tsx");
